import { Map as ImmutableMap } from 'immutable';
import { useMemo } from 'react';

// @ts-expect-error untyped module
import { parse as hubLParse } from 'automation-ui-formula-editor/formula-editor/grammar/hubL/hubLParser';
// @ts-expect-error untyped module
import { parse as editorExpressionParser } from 'automation-ui-formula-editor/formula-editor/grammar/editorExpression/editorExpressionParser';
import { toEditorExpression } from 'automation-ui-formula-editor/formula-editor/grammar/editorExpression/editorExpressionTransformer';
import * as FormulaActionMetadataKeys from 'automation-ui-action-features/actions/formula/FormulaActionMetadataKeys';
import FormulaState from 'automation-ui-formula-editor/formula-editor/model/FormulaState';
import queryObjectProperties from 'automation-ui-action-features/queries/ObjectPropertiesQuery';
import FormulaViewer from 'automation-ui-formula-editor/formula-viewer/FormulaViewer';
import { jsx as _jsx } from "react/jsx-runtime";
function FormulaViewerAdapter({
  actionMetadata,
  formattedPropertiesByGroup,
  actionOutputsForTargetActionById,
  getActionLabelById
}) {
  const variableContext = useMemo(() => ImmutableMap(actionMetadata.get(FormulaActionMetadataKeys.VARIABLE_CONTEXT).map(variable => [variable.get('name'), variable.get('value')])), [actionMetadata]);
  const templateString = actionMetadata.get(FormulaActionMetadataKeys.TEMPLATE);
  const actionOutputs = useMemo(() => {
    return ImmutableMap(actionOutputsForTargetActionById.map(({
      actionId,
      outputFieldDefinitions
    }) => {
      const actionTitle = getActionLabelById({
        actionId,
        useString: true
      });
      return [actionId, {
        actionId,
        outputFieldDefinitions,
        actionTitle,
        actionNumber: actionTitle.match && actionTitle.match(/^[0-9]+/)[0]
      }];
    }));
  }, [actionOutputsForTargetActionById, getActionLabelById]);
  const editorFormulaState = useMemo(() => {
    try {
      const parsedHubLExpression = hubLParse(templateString);
      const editorFormulaText = toEditorExpression(parsedHubLExpression);
      const parsedFormulaExpression = editorExpressionParser(editorFormulaText);
      return new FormulaState({
        formulaText: editorFormulaText,
        variableContext,
        parsedExpression: parsedFormulaExpression
      });
    } catch (_unused) {
      return null;
    }
  }, [templateString, variableContext]);
  return /*#__PURE__*/_jsx(FormulaViewer, {
    formulaState: editorFormulaState,
    propertiesByGroup: formattedPropertiesByGroup,
    actionOutputs: actionOutputs
  });
}
export default queryObjectProperties(FormulaViewerAdapter);